export class Action {
    code : string | ActionType;
    tooltip? : string;
    disable? : boolean;
    label? : string;
    labelArr? : string[];
    actionClass? : string;
    ngClass? : string;
    classes? : string;
    popup? : boolean;
    dataTarget? : string;
    dataToggle? : string;

    constructor(code : ActionType | string, label? : string, popup? : boolean){
        this.code = code;
        this.label = label;
        this.popup = popup;
    }
}

export type ActionType = "edit" | "delete" | "ltiLink" | "addItems";
